<div class="row m-3">
    @for (sample of samples; track sample.id) {
      <div class="col-md-4 col-lg-3 mt-3">
        <span class="label">Code échantillon :</span>
        <p>{{ sample.sampleCode }}</p>
      </div>
  
      <div class="col-md-4 col-lg-3 mt-3">
        <span class="label">Type :</span>
        <p>{{ sample.sampleType }}</p>
      </div>
  
      <div class="col-md-4 col-lg-3 mt-3">
        <span class="label">Méthode :</span>
        <p>{{ sample.methode }}</p>
      </div>
  
      <div class="col-md-4 col-lg-3 mt-3">
        <span class="label">Collecté par :</span>
        <p>{{ sample.collectedById }}</p>
      </div>
  
      <div class="col-md-4 col-lg-3 mt-3">
        <span class="label">Date de réception :</span>
        <p>{{ sample.dateReception | date:'shortDate' }}</p>
      </div>
  
      <div class="col-md-4 col-lg-3 mt-3">
        <span class="label">Quantité prélevée :</span>
        <p>{{ sample.qtePre }}</p>
      </div>
  
      <div class="col-md-4 col-lg-3 mt-3">
        <span class="label">Volume :</span>
        <p>{{ sample.volume }}</p>
      </div>
  
      <div class="col-md-4 col-lg-3 mt-3">
        <span class="label">Matrice :</span>
        <p>{{ sample.matriceName }}</p>
      </div>
  
      <div class="col-md-4 col-lg-3 mt-3">
        <span class="label">Client :</span>
        <p>{{ sample.socialReason }}</p>
      </div>
  
      <div class="col-md-4 col-lg-3 mt-3">
        <span class="label">Statut :</span>
        <p>{{ sample.validated ? 'Validé' : 'Non validé' }}</p>
      </div>
  
      <div class="col-md-4 col-lg-3 mt-3">
        <span class="label">Conditions de stockage :</span>
        <p>{{ sample.storageConditions }}</p>
      </div>
  
      <div class="col-md-4 col-lg-3 mt-3">
        <span class="label">Créé par :</span>
        <p>{{ sample.nameCreatedBy }}</p>
      </div>
  
      <hr class="mt-3" *ngIf="!$last" />
    } @empty {
      <div style="height: 200px" class="text-center text-muted mt-4">
        Aucun détail d’échantillon disponible.
      </div>
    }
  </div>
  